<template>
  <div class="vip-widget">
    <div class="vip-status" :class="{ 'is-vip': isVip }">
      <app-icon  class="app-icon" :name="isVip ? 'star' : 'star_border'"></app-icon>
      <span>{{ isVip ? 'VIP会员' : '普通用户' }}</span>
    </div>
    <div class="vip-balance">
      <div class="balance-item">
        <span class="balance-value">{{ balance }}</span>
        <span class="balance-label">剩余次数</span>
      </div>
    </div>
    <button class="btn-upgrade" @click="$router.push('/user/vip')">
      {{ isVip ? '续费会员' : '开通会员' }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'VipWidget',
  data() {
    return {
      isVip: false,
      balance: 0
    }
  },
  created() {
    this.$ajax.get('api/v1/users/me').then(res => {
      if (res.data) {
        this.balance = res.data.balance || 0
        this.isVip = this.balance > 0
      }
    })
  }
}
</script>

<style scoped>
.vip-widget {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.vip-status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
}

.vip-status.is-vip {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: #ffffff;
}

.vip-status .app-icon {
  font-size: 20px;
}

.vip-balance {
  display: flex;
  justify-content: center;
}

.balance-item {
  text-align: center;
}

.balance-value {
  display: block;
  font-size: 28px;
  font-weight: 700;
  color: #1a1a2e;
}

.balance-label {
  font-size: 12px;
  color: #6b7280;
}

.btn-upgrade {
  padding: 10px;
  background: #0052ff;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-upgrade:hover {
  background: #003ec7;
}
</style>



// WEBPACK FOOTER //
// src/components/User2/widgets/VipWidget.vue